"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as c } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.729 18.292a3.024 3.024 0 0 1-3.021-3.021 3.024 3.024 0 0 1 3.021-3.021 3.025 3.025 0 0 1 3.021 3.02 3.025 3.025 0 0 1-3.021 3.022m-11.459 0a3.024 3.024 0 0 1-3.02-3.021 3.024 3.024 0 0 1 3.02-3.021 3.024 3.024 0 0 1 3.021 3.02 3.024 3.024 0 0 1-3.021 3.022M22 15.237c0-.24-.003-5.911-.298-7.674-.138-.828-.327-1.96-1.186-2.681-1.256-1.053-3.181-.873-3.262-.866a.624.624 0 0 0 .123 1.244c.018 0 1.488-.132 2.335.579.506.425.64 1.224.757 1.929.143.852.212 2.776.246 4.459A4.25 4.25 0 0 0 17.729 11c-2.142 0-3.903 1.589-4.208 3.646h-3.043C10.173 12.589 8.412 11 6.27 11c-1.163 0-2.216.47-2.986 1.227.034-1.683.103-3.607.246-4.46.117-.704.251-1.503.756-1.928.849-.711 2.317-.58 2.336-.58a.624.624 0 0 0 .123-1.244c-.08-.006-2.005-.186-3.263.867-.858.72-1.047 1.853-1.185 2.68C2.002 9.327 2 14.998 2 15.238l.001.012-.001.02a4.276 4.276 0 0 0 4.27 4.27c2.142 0 3.902-1.588 4.208-3.645h3.043c.306 2.057 2.066 3.646 4.208 3.646A4.277 4.277 0 0 0 22 15.27l-.002-.022z",
        clipRule: "evenodd"
      }
    )
  }
), m = c(e);
export {
  m as Optical,
  m as default
};
